"use strict";

(function (global) {
  /**
   * Предоставляет инструменты для работы с историей. 
   */
  var History = BaseObject.extend({
    allowHistory: null,

    init: function () {
      var me = this;
      me.allowHistory = window.history && history.pushState;

      if (me.allowHistory) {
        // HACK: чтобы не ловить onpopstate при загрузке страницы в некоторых браузерах.
        window.addEventListener('load', function() {
          setTimeout(function() {
            window.addEventListener('popstate', function(event) {
              me.fire(me.EVENT.POP_STATE, event);
              me.fire(me.EVENT.CHANGE_STATE, event.state);
            });
          }, 0);
        });
      }
    },

    /**
     * Добавить состояние в историю.
     * 
     * @param {object} state Объект состояния. 
     * @param {string} title Заголовок страницы. 
     * @param {string} url URL страницы.
     */
    pushState: function (state, title, url) {
      var me = this;
      if (me.allowHistory) {
        if (!state.type) {
          state.type = WA.getLocation();
        }

        history.pushState(state, title, url);
        me.fire(me.EVENT.PUSH_STATE, state, title, url);
        me.fire(me.EVENT.CHANGE_STATE, state);
      } else {
        window.open(url, '_self');
      }
    },

    /**
     * Заменить текущее состояние. 
     * 
     * @param {object} state Объект состояния. 
     * @param {string} title Заголовок страницы. 
     * @param {string} url URL страницы.
     */
    replaceState: function (state, title, url) {
      var me = this;
      if (me.allowHistory) {
        if (!state.type) {
          state.type = WA.getLocation();
        }

        history.replaceState(state, title, url);
        me.fire(me.EVENT.PUSH_STATE, state, title, url);
        me.fire(me.EVENT.CHANGE_STATE, state);
      }
    },
    
    /**
     * События. 
     */
    EVENT: {
      /**
       * Добавлено состояние в историю. 
       */
      PUSH_STATE: 'pushstate',
      /**
       * Извлечено состояние из истории. 
       */
      POP_STATE: 'popstate',
      /**
       * Изменено текущиее состояние. 
       */
      CHANGE_STATE: 'changestate'
    }
  });

  global.history = new History();
})(WebAccess);